export const GET_CANCELLED_INVOICE_INIT = "GET_CANCELLED_INVOICE_INIT";
export const GET_CANCELLED_INVOICE_SUCCESS = "GET_CANCELLED_INVOICE_SUCCESS";
export const GET_CANCELLED_INVOICE_ERROR = "GET_CANCELLED_INVOICE_ERROR";
export const SET_CANCELLED_INVOICE_COMPLETE_INIT = "SET_CANCELLED_INVOICE_COMPLETE_INIT";
export const SET_CANCELLED_INVOICE_COMPLETE_SUCCESS = "SET_CANCELLED_INVOICE_COMPLETE_SUCCESS";
export const SET_CANCELLED_INVOICE_COMPLETE_ERROR = "SET_CANCELLED_INVOICE_COMPLETE_ERROR";